<template>
  <v-container fluid pl-3 pr-3>
    <v-dialog :retain-focus="false" v-model="showNewsDialog" @keydown.esc="closeNews()">
      <v-card-text>
        <NewsCard
          @close-dialog="closeNews()"
          :type="newsType"
          :popDialog=true
        />
      </v-card-text>
    </v-dialog>
    <v-dialog v-model="showMeetingDialog" @keydown.esc="$router.push('/')">
      <v-card>
        <MeetingDetail
          v-if="image !== ''"
          :speaker="$store.state.meetingInfo.speaker"
          :enticement="$store.state.meetingInfo.enticement"
          :title="$store.state.meetingInfo.title"
          :topic="$store.state.meetingInfo.topic"
          :meetingDate="$store.state.meetingInfo.meetingdate"
          :meeting_url="$store.state.meetingInfo.meeting_url"
          :membershare_title="$store.state.meetingInfo.membershareTitle"
          :membershare_description="$store.state.meetingInfo.membershareDescription"
          :meeting_id="$store.state.meetingInfo.id"
          @close-dialog="$router.push('/')"
        />
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12 sm6 pa-1>
        <MeetingCard
          :speaker="$store.state.meetingInfo.speaker"
          :enticement="$store.state.meetingInfo.enticement"
          :title="$store.state.meetingInfo.title"
          :image="$store.state.meetingInfo.image"
          :meetingDate="$store.state.meetingInfo.meetingdate"
          :meetingID="$store.state.meetingInfo.id"
          :location="$store.state.meetingInfo.location"
          :meeting_url="$store.state.meetingInfo.meeting_url"
		  :virtual_location="$store.state.meetingInfo.virtual_location"
          :membershareTitle="$store.state.meetingInfo.membershare_title"
          :membershareDescription="$store.state.meetingInfo.membershare_description"
        />
        <RandomGalleryCard :imageID="$store.state.meetingInfo.randomGalleryImageID" :imageURL="$store.state.meetingInfo.randomGalleryImage" :galleryName="$store.state.meetingInfo.randomGalleryName" :isExhibition="$store.state.meetingInfo.randomGalleryIsExhibition" :photographer="$store.state.meetingInfo.randomGalleryPhotographer" :galleryID="$store.state.meetingInfo.randomGalleryID" :comments="$store.state.meetingInfo.randomGalleryComments"/>
      </v-flex>
      <v-flex xs12 sm6 pa-1>
        <NewsCard
          title="North County Photographic Society (NCPS)"
          :text="about_index"
          type="about_index"
        />
        <NewsCard
          title="NCPS Sponsor News"
          :text="sponsorAnnouncement"
          type="sponsor"
        />
        <NewsCard
          title="Latest NCPS News"
          :text="memberAnnouncement"
          type="member"
        />
      </v-flex>
      <!-- <v-flex xs12 sm6 pa-1>
        <SearchPhotos/>
      </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
import NewsCard from '@/components/NewsCard'
import MeetingCard from '@/components/MeetingCard'
import MeetingDetail from '@/components/MeetingDetail'
import RandomGalleryCard from '@/components/RandomGalleryCard'
// import SearchPhotos from '@/components/SearchPhotos'
import { TokenService } from '@/services/storage.service'

export default {
  components: {
    NewsCard,
    MeetingCard,
    RandomGalleryCard,
    MeetingDetail,
    // SearchPhotos
  },
  computed: {
    website: function () {
      return process.env.VUE_APP_WEBSITE
    },
    image: function() {
      if (this.$store.state.meetingInfo.meetingDate != null ) {
        return process.env.VUE_APP_WEBSITE + '/meeting/' + this.$store.state.meetingInfo.meetingDate.substring(0, 7) + '/speaker_01.jpg'
      }
    }
  },
  watch: {
    '$store.state.meetingInfo.about_index' (to) {
      this.about_index = to
    },
    '$store.state.meetingInfo.sponsorAnnouncement' (to) {
      this.sponsorAnnouncement = to
    },
    '$store.state.meetingInfo.memberAnnouncement' (to) {
      this.memberAnnouncement = to
    },
    // eslint-disable-next-line
    '$route' (to) {
      // react to route changes...
      if (to.path === '/') {
        this.showMeetingDialog = false
        this.showNewsDialog = false
      }
      if (to.name === 'meeting') {
        this.showMeetingDialog = true
      }
      if (to.name === 'info') {
        this.newsType = this.$route.params.id
        this.showNewsDialog = true
      }
    },
    // Capture user clicks outside dialog, which cause it to close
    // eslint-disable-next-line
    'showNewsDialog' (to, from) {
      if (to === false) {
        this.closeNews()
      }
    },
    // eslint-disable-next-line
    'showMeetingDialog' (to, from) {
      if (to === false) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    closeNews () {
      if (this.$route.query.redirect) {
        this.$router.replace(this.$route.query.redirect)
      } else {
        this.$router.push('/')
      }
    },
    loadMeetingInfo () {
      // TokenService.loadMeetingInfo()
    }
  },
  data: function () {
    return {
      showMeetingDialog: false,
      newsType: '',
      showNewsDialog: false,
      about_index: '',
      sponsorAnnouncement: '',
      memberAnnouncement: '',
    }
  },
  mounted () {
    // this.loadMeetingInfo()
    this.about_index = this.$store.state.meetingInfo.about_index
    this.sponsorAnnouncement = this.$store.state.meetingInfo.sponsorAnnouncement
    this.memberAnnouncement = this.$store.state.meetingInfo.memberAnnouncement

    if (this.$route.name === 'meeting') {
      this.showMeetingDialog = true
    }
    if (this.$route.name === 'info') {
      this.newsType = this.$route.params.id
      this.showNewsDialog = true
    }
  }
}
</script>

<style scoped>
.rounded-card {
  border-radius: 7px;
}
</style>
